import { Box, Divider, Paper, Typography } from '@mui/material';
import { withClarityTheme } from '@verifime/styles';
import RedactedPill from './RedactedPill';

export type TRedactedCustomerProps = {
  name: string | null;
  id: string;
  entityType: string;
  redactedAt: string;
  redactedBy: string;
  redactionReason: string;
};

function RedactedCustomer({
  name,
  id,
  entityType,
  redactedAt,
  redactedBy,
  redactionReason,
}: TRedactedCustomerProps) {
  return (
    <Paper
      variant="outlined"
      sx={(theme) => ({
        padding: theme.card.padding,
        borderRadius: theme.card.borderRadius,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.card.contentGap,
      })}
    >
      <Box>
        <Box
          sx={(theme) => ({
            display: 'flex',
            alignItems: 'center',
            gap: theme.semantic.spacing.sm,
            mb: theme.semantic.spacing['2xs'],
          })}
        >
          <Typography variant="h5">
            {name ?? 'Name unavailable'}
          </Typography>
          <RedactedPill />
        </Box>
        <Typography
          variant="body2"
          sx={(theme) => ({
            color: theme.palette.text.secondary,
          })}
        >
          {entityType} &middot; {id}
        </Typography>
      </Box>

      <Divider />

      <Box
        sx={(theme) => ({
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: theme.card.itemGap,
        })}
      >
        <Box>
          <Typography
            variant="overline"
            sx={(theme) => ({
              color: theme.palette.text.secondary,
            })}
          >
            Redacted on
          </Typography>
          <Typography variant="body2">{redactedAt}</Typography>
        </Box>
        <Box>
          <Typography
            variant="overline"
            sx={(theme) => ({
              color: theme.palette.text.secondary,
            })}
          >
            Actioned by
          </Typography>
          <Typography variant="body2">{redactedBy}</Typography>
        </Box>
      </Box>

      <Box
        sx={(theme) => ({
          backgroundColor: theme.palette.action.hover,
          borderRadius: theme.semantic.borderRadius.sm,
          p: theme.semantic.spacing.sm,
        })}
      >
        <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
          {redactionReason}
        </Typography>
      </Box>
    </Paper>
  );
}

export default withClarityTheme(RedactedCustomer);
